import { TFieldConfig } from "../../types/common";
import { API_USSD_INPUT_LOGS } from "../../utils/apis";
import { createColumn, formatDateTime } from "../../utils/helpers";

export const useUSSDInputlogs = () => {
  const searchFields: TFieldConfig[] = [
    {
      field_name: "phoneNumber",
      label: "Phone Number",
      type: "text",
      props: { placeholder: "2567XXXXXXXX", required: true },
    },
    {
      field_name: "sessionId",
      label: "Session ID",
      type: "text",
      props: { required: true },
    },
  ];

  const tableColumns = () => [
    createColumn("sessionId", false, "Session ID"),
    createColumn("phone_number", false, "Phone Number"),
    createColumn("service_code", false, "Service Code"),
    createColumn("created_at", false, "Started At"),
  ];

  const tableData = (data: any[]) =>
    data.map((row) => ({
      ...row,
      created_at: formatDateTime(row.created_at),
    }));

  return {
    searchFields,
    tableColumns,
    tableData,
    api: API_USSD_INPUT_LOGS,
    tableTitle: "USSD Input Logs",
    initialFilters: {},
  };
};
